var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20C10.2667 20 8.375 19.225 6.825 17.675C5.275 16.125 4.5 14.2333 4.5 12C4.5 9.76667 5.275 7.875 6.825 6.325C8.375 4.775 10.2667 4 12.5 4C13.65 4 14.75 4.23734 15.8 4.712C16.85 5.18667 17.75 5.866 18.5 6.75V5C18.5 4.71667 18.596 4.47934 18.788 4.288C18.98 4.09667 19.2173 4.00067 19.5 4C19.7827 3.99934 20.0203 4.09534 20.213 4.288C20.4057 4.48067 20.5013 4.718 20.5 5V10C20.5 10.2833 20.404 10.521 20.212 10.713C20.02 10.905 19.7827 11.0007 19.5 11H14.5C14.2167 11 13.9793 10.904 13.788 10.712C13.5967 10.52 13.5007 10.2827 13.5 10C13.4993 9.71734 13.5953 9.48 13.788 9.288C13.9807 9.096 14.218 9 14.5 9H17.7C17.1667 8.06667 16.4377 7.33334 15.513 6.8C14.5883 6.26667 13.584 6 12.5 6C10.8333 6 9.41667 6.58334 8.25 7.75C7.08333 8.91667 6.5 10.3333 6.5 12C6.5 13.6667 7.08333 15.0833 8.25 16.25C9.41667 17.4167 10.8333 18 12.5 18C13.6333 18 14.671 17.7127 15.613 17.138C16.555 16.5633 17.284 15.7923 17.8 14.825C17.9333 14.5917 18.121 14.4293 18.363 14.338C18.605 14.2467 18.8507 14.2423 19.1 14.325C19.3667 14.4083 19.5583 14.5833 19.675 14.85C19.7917 15.1167 19.7833 15.3667 19.65 15.6C18.9667 16.9333 17.9917 18 16.725 18.8C15.4583 19.6 14.05 20 12.5 20Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearChat);
export default __webpack_public_path__ + "static/media/clearChat.5f9ec7d1f1aeeae4543019c74483adcd.svg";
export { ForwardRef as ReactComponent };